import React from "react";
import { RefluxComponent } from "sp-react-commons";
import Translation from "../i18n/Translation";

import UserStore from "../stores/UserStore";
import UserActions from "../actions/UserActions";

import Svg from "../../../svg/Svg";

class AddPostButtonPresenter extends React.Component {

    renderFloatAction = () => {
        return <a href={"/" + Translation.getLanguageName() + "/mywort/edit#/post/create"} className="mywort-btn--float-action">
            <Svg id="watermark-blog" className="mywort-header__btn__svg"/>
        </a>
    };

    renderInlineButton = () => {
        return <a href={"/" + Translation.getLanguageName() + "/mywort/edit#/post/create"} className="mywort-btn mywort-btn--big-letters mywort-btn--outlined-transparent mywort-btn--radius mywort-header__btn">
            <Svg id="watermark-blog" className="mywort-header__btn__svg"/> <span className="hide-for-small hide-for-medium">{Translation.translate("commons.new-contribution")}</span>
        </a>
    };


    render = () => {
        if(this.props.style === 'float')
            return this.renderFloatAction();
        else
            return this.renderInlineButton();
    }
}

export default class AddPostButton extends RefluxComponent {
    initialState = () => ({
    });

    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    componentDidMount() {
        this.listenTo(UserStore, this._onStoreChange);
        UserActions.getUser();
    }

    _onStoreChange = (data) => {
        this.setState({ user: data.user });
    };

    render = () => {
        if(this.state.user && this.state.user.myWortAccess) {
            return <AddPostButtonPresenter user={this.state.user} style={this.props.style}/>;
        }
        return null;
    };
}



// WEBPACK FOOTER //
// ./js/mywort/commons/components/AddPostButton.jsx